// extracted by mini-css-extract-plugin
export default {"root":"Evidence_root__smBmf","progress":"Evidence_progress__Vigym"};